import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "2.8",
  y: "3.616",
  fill: "currentColor",
  rx: "1.4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "2.8",
  y: "9.416",
  fill: "currentColor",
  rx: "1.4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "2.8",
  y: "15.216",
  fill: "currentColor",
  rx: "1.4"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }